module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('reservation-payment', {
    tag: "div",
    attrs: {
      "direction": 0
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efba4bec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn.vue
// module id = 1818
// module chunks = 0